import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'alg-sconto-header',
  templateUrl: './alg-sconto-header.component.html',
  styleUrls: ['./alg-sconto-header.component.scss']
})
export class AlgScontoHeaderComponent implements OnInit {
  @Input() reverse: boolean;
  public websiteUrl: string = environment.websiteUrl;
  constructor() { }

  public restart(){
    window.location.href = window.location.href;
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-sconto-header/alg-sconto-header.component.ts